import { render, staticRenderFns } from "./CreatePermission.vue?vue&type=template&id=674f6ea8&scoped=true"
import script from "./CreatePermission.vue?vue&type=script&lang=js"
export * from "./CreatePermission.vue?vue&type=script&lang=js"
import style0 from "./CreatePermission.vue?vue&type=style&index=0&id=674f6ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f6ea8",
  null
  
)

export default component.exports